import React, { useEffect, useState } from "react";
import Leftsidebar from "../sidebar/leftsidebar";
import LeftResponsivesidebar from "../sidebar/left-responsive";
import Headmenu from "../sidebar/headmenu";
import BannerProfile from "./BannerProfile";
import { TiLocation } from "react-icons/ti";
import { CiShop } from "react-icons/ci";
import { FaMobile } from "react-icons/fa6";
import { FaMessage } from "react-icons/fa6";
import { TbWorldSearch } from "react-icons/tb";
import PostBox from "./PostBox";
import PostCard from "./PostCards";
import EditProfile from "./EditProfile";
import MyProject from "./MyProject";
import { getsellerprofile } from "../../hook/useapi";
import axios from "axios";
import CreatepostforSeller from "../feedpost/createpostforseller";
import PostPopup from "../common/PostPopup";
import ShareModal from "../ShareModal";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const Profile = () => {
  const navigate = useNavigate(); // Navigation hook

  const [tabs, setTabs] = useState(1);
  const [profiledate, setProfiledate] = useState();
  const [sellerProfileChecked, setSellerProfileChecked] = useState(false);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);
  const [selectedPostId, setSelectedPostId] = useState(null);
  const [comments, setComments] = useState([]);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [currentPostUrl, setCurrentPostUrl] = useState("");

  const tabslist = [
    {
      id: 1,
      name: "Posts",
    },
    {
      id: 2,
      name: "About",
    },
    {
      id: 3,
      name: "My Products",
    },
  ];
  const fetchSellerPosts = async () => {
    if (loading || !hasMore) return; // prevent duplicate calls
    if (!profiledate?.id) return; // wait until seller profile is loaded

    setLoading(true);
    setError(null);

    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    if (!token) {
      setError("Authentication token is missing. Please log in again.");
      setLoading(false);
      return;
    }

    const requestBody = {
      filters: {
        seller_id: Number(profiledate.id),
        is_seller_post: true, // ✅ enforce seller post only
      }, // ✅ seller_id as string
      page,
      limit: 10,
    };

    try {
      const response = await fetch(
        `${API_BASE_URL}/post/get-posts`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token,
          },
          body: JSON.stringify(requestBody),
        }
      );

      const data = await response.json();

      if (response.ok && data.success) {
        const newPosts = data.result.posts;

        setPosts((prev) => {
          const existingIds = new Set(prev.map((p) => p.id));
          const filtered = newPosts.filter((p) => !existingIds.has(p.id));
          return [...prev, ...filtered];
        });

        setHasMore(newPosts.length === 10); // load more if full page returned
        setPage((prev) => prev + 1);
      } else {
        setError(data.message || "Failed to fetch posts.");
      }
    } catch (err) {
      console.error("❌ Error fetching posts:", err);
      setError("An error occurred while fetching posts.");
    } finally {
      setLoading(false);
    }
  };

  // Fetch post by ID (your existing function)
  const fetchPostById = async (postId) => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    try {
      const response = await fetch(
        `${API_BASE_URL}/post/get-post-by-id?id=${postId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            token,
          },
        }
      );
      const data = await response.json();
      if (data.success && data.result) {
        setSelectedPost(data.result);
        setSelectedPostId(data.result.id);
      }
    } catch (err) {
      console.error("Error fetching post:", err);
    }
  };

  const fetchComments = async (postId) => {
    try {
      const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
      const res = await fetch(
        `${API_BASE_URL}/comment/get-comments`,
        {
          method: "POST", // ✅ use POST instead of GET
          headers: {
            "Content-Type": "application/json",
            token,
          },
          body: JSON.stringify({
            filters: {
              post_id: String(postId), // ✅ body must include post_id as string
            },
            page: 1,
            limit: 20, // optional pagination
          }),
        }
      );

      const data = await res.json();
      if (data.success) {
        setComments(data.result.comments);
      } else {
        console.error("❌ Failed to fetch comments:", data.message);
      }
    } catch (err) {
      console.error("Error fetching comments:", err);
    }
  };

  // Open popup
  const openPopup = (post) => {
    setSelectedPostId(post.id);
    setIsPopupOpen(true);
    fetchPostById(post.id);
    fetchComments(post.id);
  };
  const [showSellerModal, setShowSellerModal] = useState(false);

  const HandleGEtsellerProfile = async () => {
    try {
      const res = await axios.post(
        `${API_BASE_URL}/seller/get-seller-profile`,
        {}, // empty request body
        {
          headers: {
            token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Seller Profile:", res);
      const result = res?.data?.result;
      setProfiledate(result);
      // persist seller id for other components to use
      if (result?.id) {
        try {
          sessionStorage.setItem("sellerId", String(result.id));
          localStorage.setItem("sellerId", String(result.id));
          const result = res?.data?.result;
          setProfiledate(result);
          // persist seller id for other components to use
          if (result?.id) {
            try {
              sessionStorage.setItem("sellerId", String(result.id));
              localStorage.setItem("sellerId", String(result.id));
            } catch (e) {
              console.warn("Unable to persist sellerId to sessionStorage", e);
            }
          }
        } catch (error) {}
      }
    } catch (error) {
      console.error("Error fetching seller profile:", error);
      // ✅ SHOW MODAL INSTEAD OF ALERT
    if (error?.response?.status === 409) {
      setShowSellerModal(true);
    } else {
      toast.error(
        error?.response?.data?.message ||
          "Failed to fetch seller profile."
      );
    }
  } finally {
    setSellerProfileChecked(true);
  }
};

  useEffect(() => {
    HandleGEtsellerProfile();
  }, []);

  useEffect(() => {
    if (profiledate?.id) {
      setPosts([]); // reset posts
      setPage(1);
      setHasMore(true);
      fetchSellerPosts();
    }
  }, [profiledate]);

  return (
    <div className="dashboard w-full min-h-screen  flex">
      <Leftsidebar />
      <main className="flex-1 min-w-0 p-4 md:p-6 md:pl-8">
        <LeftResponsivesidebar />
        <Headmenu />
        <main className="flex">
          <div className="w-[100%]">
            {sellerProfileChecked && !profiledate?.id ? (
              // No seller profile yet: don't show any seller data, tabs or products
              <div className="flex flex-col items-center justify-center text-center py-20 px-4 bg-white rounded-[24px] mt-6">
                <div className="w-20 h-20 rounded-full bg-[#095228]/10 flex items-center justify-center mb-4">
                  <CiShop className="w-10 h-10 text-[#095228]" />
                </div>
                <h3 className="text-lg font-semibold text-gray-800">
                  You haven't set up your seller profile yet
                </h3>
                <p className="text-sm text-gray-500 mt-2 max-w-md">
                  Create your seller profile to add products and manage your shop.
                </p>
                <button
                  onClick={() => navigate("/sellerInformation")}
                  className="mt-6 bg-[#095228] hover:bg-[#0b6a33] text-white rounded-full px-6 py-2.5 font-semibold"
                >
                  Create Seller Profile
                </button>
              </div>
            ) : (
            <>
            <div>
              <BannerProfile profiledate={profiledate} />
            </div>

            <div className="flex flex-col md:flex-row mt-20 w-full gap-6 md:gap-10">
              <div className="w-full md:w-[65%]">
                <div className="space-y-2 bg-gradient-to-r from-[#E3F4FB] to-[#DDF7EA] border border-[#BFE6D3] p-4 rounded-xl">
                  <p className="font-semibold">Intro</p>
                  <p className="text-sm text-gray-700 whitespace-pre-line break-words">
                    {profiledate?.store_description || "No intro added yet."}
                  </p>
                </div>
              </div>
              <div className="w-full md:w-[35%]">
                <div className="space-y-4 text-sm">
                  {(profiledate?.location || profiledate?.country) && (
                    <p className="flex gap-2 items-center">
                      <TiLocation className="text-xl text-gray-400 shrink-0" />
                      <span>
                        Location{" "}
                        <span className="font-semibold">
                          {[profiledate.location, profiledate.country].filter(Boolean).join(", ")}
                        </span>
                      </span>
                    </p>
                  )}
                  {profiledate?.mobile_number && (
                    <p className="flex gap-2 items-center">
                      <FaMobile className="text-xl text-gray-400 shrink-0" />
                      <a href={`tel:${profiledate.mobile_number}`} className="font-semibold">
                        {profiledate.mobile_number}
                      </a>
                    </p>
                  )}
                  {profiledate?.email && (
                    <p className="flex gap-2 items-center">
                      <FaMessage className="text-xl text-gray-400 shrink-0" />
                      <a href={`mailto:${profiledate.email}`} className="font-semibold break-all">
                        {profiledate.email}
                      </a>
                    </p>
                  )}
                  {profiledate?.website && (
                    <p className="flex gap-2 items-center">
                      <TbWorldSearch className="text-xl text-gray-400 shrink-0" />
                      <a
                        href={/^https?:\/\//i.test(profiledate.website) ? profiledate.website : `https://${profiledate.website}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="font-semibold underline break-all"
                      >
                        {profiledate.website}
                      </a>
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div className="mt-10">
              {/* <PostBox /> */}
              <CreatepostforSeller sellerId={profiledate?.id} />
            </div>
            <div className="mt-10">
              <div className="flex gap-4 lg:gap-10">
                {tabslist.map((res, i) => (
                  <button
                    key={i}
                    onClick={() => setTabs(res.id)}
                    className={`flex-1 lg:flex-none lg:w-[180px] border-b-[3px] text-start text-base md:text-xl font-semibold py-2 whitespace-nowrap transition duration-200 ${
                      res.id === tabs
                        ? "border-[#095228] text-[#095228]"
                        : "border-[#ccc] text-gray-500"
                    }`}
                  >
                    {res?.name || "xxxxxxx"}
                  </button>
                ))}
              </div>

              {tabs === 1 ? (
                <div>
                  {!loading && posts.length === 0 && (
                    <p className="py-10 text-center text-gray-500">{error || "No posts yet"}</p>
                  )}
                  {posts.map((post) => (
                    <div key={post.id}>
                      {/* <button
                        onClick={() => openPopup(post)}
                        className="w-full text-left"
                      > */}
                      <PostCard post={post} profiledate={profiledate} />
                      {/* </button> */}
                    </div>
                  ))}
                </div>
              ) : tabs === 2 ? (
                <div>
                  <EditProfile
                    profiledate={profiledate}
                    HandleGEtsellerProfile={HandleGEtsellerProfile}
                  />
                </div>
              ) : (
                tabs === 3 && (
                  <div>
                    {/* <MyProject /> */}
                    <MyProject
                      sellerId={profiledate?.id || null}
                      sellerStatus={profiledate?.seller_status}
                    />
                  </div>
                )
              )}
            </div>
            </>
            )}
          </div>
        </main>
      </main>
      <ShareModal
        isOpen={isShareModalOpen}
        onClose={() => setIsShareModalOpen(false)}
        shareUrl={currentPostUrl}
      />

{showSellerModal && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
    <div className="bg-white rounded-xl w-full max-w-[400px] p-6 text-center shadow-lg">
      <h2 className="text-lg font-semibold mb-3">
        Seller Profile Not Found
      </h2>

      <p className="text-gray-600 mb-6">
        Please complete your seller information to continue.
      </p>

      <div className="flex justify-center gap-4">
        <button
          onClick={() => setShowSellerModal(false)}
          className="px-4 py-2 rounded-lg border border-gray-300"
        >
          Cancel
        </button>

        <button
          onClick={() => {
            setShowSellerModal(false);
            navigate("/sellerInformation");
          }}
          className="px-4 py-2 rounded-lg bg-[#095228] text-white"
        >
          Create Seller Profile
        </button>
      </div>
    </div>
  </div>
)}

      {/* ✅ Post Popup */}
      <PostPopup
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
        selectedPost={selectedPost}
        comments={comments}
        fetchComments={fetchComments}
      />
    </div>
    
  );
};

export default Profile;
